//LOGIN
export const LOGIN = "/auth/admin/login";
export const VERIFY_TOKEN = "/auth/verify-token/";
export const FORGOT = "/auth/forget-password";
export const RESET = "/auth/reset-password/";
export const GET_PROFILE = "/auth/profile";
export const UPDATE_PROFILE = "/auth/update-profile";
export const CHANGE_PROFILE = "/auth/change-password";
export const CHANGE_EMAIL = "/auth/change-email";
export const OTP_VERIFY = "/auth/email/verify-OTP";

//Group
export const GROUP = "/admin/group";
export const GROUP_LIST = "/common/group/list";
export const GROUP_UPDATE = "/admin/group/";
export const GROUP_DELETE = "/admin/group/";
export const GROUP_STATUS = "/admin/group/change-status/";
export const GROUP_REQUEST = "/admin/group/pool-user/request";

//Content
export const CONTENT = "/admin/content";
export const CONTENT_LIST = "/admin/content/list";
export const CONTENT_GET = "/admin/content/";
export const CONTENT_UPDATE = "/admin/content/";
export const CONTENT_DELETE = "/admin/content/";
export const CONTENT_STATUS = "/admin/content/change-status/";

//Email
export const EMAIL = "/admin/email";
export const EMAIL_LIST = "/admin/email/list";
export const EMAIL_GET = "/admin/email/";
export const EMAIL_UPDATE = "/admin/email/";
export const EMAIL_DELETE = "/admin/email/";
export const EMAIL_STATUS = "/admin/email/change-status/";

//Notification
export const Notification = "/admin/notification";
export const Notification_LIST = "/admin/notification/list";
export const Notification_STATUS = "/admin/notification/change-status/";

//Notification
export const NOTIFICATION = "/admin/notification";
export const NOTIFICATION_ADMIN = "/admin/notification/my-list";
export const NOTIFICATION_LIST = "/admin/notification/list";
export const NOTIFICATION_UPDATE = "/admin/notification/";
export const NOTIFICATION_GET = "/admin/notification/";
export const NOTIFICATION_DELETE = "/admin/notification/";
export const NOTIFICATION_STATUS = "/admin/notification/change-status/";
export const NOTIFICATION_ADMIN_DELETE = "/common/notification";
export const NOTIFICATION_ADMIN_READ = "/common/notification-read";

//Customer
export const CUSTOMER = "/admin/customer";
export const CUSTOMER_LIST = "/admin/customer";
export const CUSTOMER_UPDATE = "/admin/customer/";
export const CUSTOMER_DELETE = "/admin/customer/";
export const CUSTOMER_STATUS = "/admin/customer/change-status/";

//Wager
export const WAGER = "/admin/wager";
export const WAGER_LIST = "/admin/wager";
export const WAGER_UPDATE = "/admin/wager/";
export const WAGER_DELETE = "/admin/wager/";
export const WAGER_STATUS = "/admin/wager/change-status/";

//Category1
export const CATEGORY_LV1 = "/admin/category/lv1";
export const CATEGORY_LV1_LIST = "/common/category/lv1/list";
export const CATEGORY_LV1_UPDATE = "/admin/category/lv1/";
export const CATEGORY_LV1_DELETE = "/admin/category/lv1/";
export const CATEGORY_LV1_STATUS = "/admin/category/lv1/change-status/";

//Category2
export const CATEGORY_LV2 = "/admin/category/lv2";
export const CATEGORY_LV2_LIST = "/common/category/lv2/list";
export const CATEGORY_LV2_UPDATE = "/admin/category/lv2/";
export const CATEGORY_LV2_DELETE = "/admin/category/lv2/";
export const CATEGORY_LV2_STATUS = "/admin/category/lv2/change-status/";

//Category3
export const CATEGORY_LV3 = "/admin/category/lv3";
export const CATEGORY_LV3_LIST = "/common/category/lv3/list";
export const CATEGORY_LV3_UPDATE = "/admin/category/lv3/";
export const CATEGORY_LV3_DELETE = "/admin/category/lv3/";
export const CATEGORY_LV3_STATUS = "/admin/category/lv3/change-status/";

//Category4
export const CATEGORY_LV4 = "/admin/category/lv4";
export const CATEGORY_LV4_LIST = "/common/category/lv4/list";
export const CATEGORY_LV4_UPDATE = "/admin/category/lv4/";
export const CATEGORY_LV4_DELETE = "/admin/category/lv4/";
export const CATEGORY_LV4_STATUS = "/admin/category/lv4/change-status/";

//Category5
export const CATEGORY_LV5 = "/admin/category/lv5";
export const CATEGORY_LV5_LIST = "/common/category/lv5/list";
export const CATEGORY_LV5_UPDATE = "/admin/category/lv5/";
export const CATEGORY_LV5_DELETE = "/admin/category/lv5/";
export const CATEGORY_LV5_STATUS = "/admin/category/lv5/change-status/";

//Banner
export const BANNER = "/admin/banner";
export const BANNER_LIST = "/common/banner/list";
export const BANNER_UPDATE = "/admin/banner/";
export const BANNER_DELETE = "/admin/banner/";
export const BANNER_STATUS = "/admin/banner/change-status/";

//Bet
export const BET = "/common/bet-add";
export const BET_LIST = "/admin/bet/list";
export const BET_GET = "/admin/bet/";
export const BET_UPDATE = "/admin/bet/";
export const BET_DELETE = "/admin/bet/";
export const BET_STATUS = "/admin/bet/change-status/";
export const SET_WINNING_OPTION = "/admin/bet/bet-winner/";

export const AVATAR_LIST = "/common/avatar/list";
export const AVATAR = "/admin/avatar";
export const AVATAR_UPDATE = "/admin/avatar/";
export const AVATAR_DELETE = "/admin/avatar/";
export const AVATAR_STATUS = "/admin/avatar/change-status/";

//Dashboard
export const TOTAL_COUNT = "/admin/dashboard/total-count";
export const GRAPH_DATA = "/admin/dashboard/graph-data";
export const JOINED_BET = "/common/joined-bet/";
export const CREATED_BET = "/common/created-bet/";

//PayOut
export const PAYOUT = "/admin/payout";

//Analytics Reportings

export const ANALYTICS_REPORTING = "/admin/analytics-report";
